/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { InputContainerModule } from '../input-container/input-container.module';
import { OptionModule } from '../option/option.module';
import { SelectComponent } from './select.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { SingleSelectComponent } from './single-select/single-select.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { PillModule } from "@ng-falcon/pill/pill.module";
import { ResponsivePillListModule } from "@ng-falcon/pill/responsive-pill-list/responsive-pill-list.module";
import { NgFalconCommonModule } from "@ng-falcon/+legacy/ng-falcon-common.module";
import { MultiSelectPillsComponent } from './multi-select-pills/multi-select-pills.component';
import { NgfTooltipDirective } from '@ng-falcon/ngf-tooltip/ngf-tooltip.directive';
import { NgfOverflowDirective } from '@ng-falcon/ngf-overflow/ngf-overflow.directive';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    MatIconModule,
    OptionModule,
    InputContainerModule,
    PillModule,
    ResponsivePillListModule,
    NgFalconCommonModule,
    NgfTooltipDirective,
    NgfOverflowDirective,
    SingleSelectComponent,
    SelectInputComponent
  ],
  declarations: [
    SelectComponent,
    MultiSelectComponent,
    MultiSelectPillsComponent,
  ],
  exports: [OptionModule, SelectComponent, SelectInputComponent],
})
export class SelectModule {}
